module.exports = __webpack_public_path__ + "static/img/istatistik.832604b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/istatistik.png
// module id = cRH7
// module chunks = 1